import { POOrderHeaderDp, PORequisitionHeaderDP } from '../../../common/lookups/Layouts/POLayouts';
import { IDLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';

const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Module",
                "tableName": "POREQUISITION",
                "label": "Module",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Method",
                "tableName": "POREQUISITION",
                "label": "Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransDate",
                "tableName": "POREQUISITION",
                "label": "Trans. Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description",
                "tableName": "POREQUISITION",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [

            {
                "name": "RequiredDate",
                "tableName": "POREQUISITION",
                "label": "Required",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TargetType",
                "tableName": "POREQUISITION",
                "label": "Target Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "InventBasis",
                "tableName": "POREQUISITION",
                "label": "Invent. Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LotStatus",
                "tableName": "POREQUISITION",
                "label": "Lot Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "PoProfile",
                "tableName": "POREQUISITION",
                "label": "PO Profile",
                "type": "lookup",
                "layout": POOrderHeaderDp,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RequisitionProfile",
                "tableName": "POREQUISITION",
                "label": "Requisition Profile",
                "type": "lookup",
                "layout": PORequisitionHeaderDP,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "InclVendor",
                "tableName": "POREQUISITION",
                "label": "Incl. Vendor",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ExpirationDate",
                "tableName": "POREQUISITION",
                "label": "Expiration",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "Reference",
                "tableName": "POREQUISITION",
                "label": "Reference #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "ExpectedDate",
                "tableName": "POREQUISITION",
                "label": "Expected",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "Comment",
                "tableName": "POREQUISITION",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export {
    SearchLayout
}